export default "__VITE_ASSET__DrWzVFl6__"